import React from "react";
import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { B2BRoutes } from "./constants/routes";

const B2B = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {B2BRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/stories" />
      </Switch>
    </>
  );
};
export default B2B